import React from 'react';
import styled from 'styled-components';

const Conatiner = styled.div`
  margin-bottom: 30px;
`;

function Policy() {
  return (
    <Conatiner>
    </Conatiner>
  )
}

export default Policy;
